import { render, staticRenderFns } from "./largeScreenData.vue?vue&type=template&id=b9491266&scoped=true&"
import script from "./largeScreenData.vue?vue&type=script&lang=js&"
export * from "./largeScreenData.vue?vue&type=script&lang=js&"
import style0 from "./largeScreenData.vue?vue&type=style&index=0&id=b9491266&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9491266",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9491266')) {
      api.createRecord('b9491266', component.options)
    } else {
      api.reload('b9491266', component.options)
    }
    module.hot.accept("./largeScreenData.vue?vue&type=template&id=b9491266&scoped=true&", function () {
      api.rerender('b9491266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/largeScreenData/largeScreenData.vue"
export default component.exports